<template>
  <div class="loading-screen">
    <!-- Centered content -->
    <div class="loading-screen__content">
      <h1 class="loading-screen__brand">
        Kaizen
      </h1>
      <!-- <Loader
        variant="dots"
        color="primary"
        size="md"
      /> -->
      <HLSpin />
      <p class="loading-screen__subtitle">
        Loading your workspace...
      </p>
    </div>

    <!-- Footer -->
    <!-- <div class="loading-screen__footer">
      <p class="loading-screen__footer-text">
        Made with ❤️ using <span class="highrise-copy-highlight">HighRise</span>
      </p>
    </div> -->
  </div>
</template>

<script setup>
import { HLSpin } from "@platform-ui/highrise";
// import Loader from "./Loader.vue";
</script>

<style scoped>
.loading-screen {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--secondary-25);
  background-image:
    radial-gradient(ellipse at 30% 20%, var(--primary-50) 0%, transparent 50%),
    radial-gradient(ellipse at 70% 80%, var(--tertiary-25) 0%, transparent 50%);
}

.dark .loading-screen {
  background: var(--neutral-900);
  background-image:
    radial-gradient(ellipse at 30% 20%, var(--primary-900) 0%, transparent 50%),
    radial-gradient(ellipse at 70% 80%, var(--tertiary-900) 0%, transparent 50%);
}

.loading-screen__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}

.loading-screen__brand {
  font-family: "Inter var", "Inter", system-ui, sans-serif;
  font-size: 2.5rem !important;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: var(--primary-500);
  margin: 0;
}

.dark .loading-screen__brand {
  color: var(--primary-400);
}

.loading-screen__subtitle {
  font-family: "Inter var", "Inter", system-ui, sans-serif;
  font-size: 1rem !important;
  font-weight: 400;
  color: var(--neutral-500);
  margin: 0;
}

.dark .loading-screen__subtitle {
  color: var(--neutral-400);
}

.loading-screen__footer {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}

.loading-screen__footer-text {
  font-family: "Inter var", "Inter", system-ui, sans-serif;
  font-size: 1.25rem !important;
  font-weight: 500;
  color: var(--neutral-400);
  margin: 0;
}

.dark .loading-screen__footer-text {
  color: var(--neutral-500);
}

.highrise-copy-highlight {
  background: -webkit-linear-gradient(120deg, #bd34fe 30%, #41d1ff);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}
</style>
